import { request } from '@services'
import { STATUS_REQUEST } from '@utils/constant'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getStatus(state) {
    return state.status
  },
  getErrors(state) {
    return state.errors
  },
}

export const mutations = {
  SET_FEEDBACK_REQUESTED(state) {
    state.loading = true
  },
  SET_FEEDBACK_RECEIVED(state) {
    state.loading = false
    state.status = STATUS_REQUEST.SUCCESS
    state.errors = null
  },
  SET_FEEDBACK_FAILED(state, errors) {
    state.loading = false
    state.status = STATUS_REQUEST.FAILED
    state.errors = errors
  },
  RESET_FEEDBACK_FAILED(state) {
    state.loading = false
    state.status = null
    state.errors = null
  },
}

export const actions = {
  async registrationFeedback({ commit }, params) {
    commit('SET_FEEDBACK_REQUESTED')
    try {
      const response = await request({
        endpoint: 'cms/agent/feedback/',
        payload: {
          ...params,
        },
      })
      commit('SET_FEEDBACK_RECEIVED')
      return response
    } catch (error) {
      commit('SET_FEEDBACK_FAILED', error)
    }
  },
  resetFeedback({ commit }) {
    commit('RESET_FEEDBACK_FAILED')
  },
}
